/** Internal CRM path from an email or deep link. Rejects off-site targets. */
export function safeReturnUrl(raw: string | null | undefined): string | null {
  if (!raw) return null;
  const value = raw.trim();
  if (!value.startsWith('/') || value.startsWith('//')) return null;
  if (value.includes('\\') || value.includes('://') || value.includes('@')) return null;
  if (value === '/login' || value.startsWith('/login?') || value.startsWith('/login/')) return null;
  return value;
}

/** Query to restore after sign-in. Omitted when the attempted URL is not internal. */
export function loginNavigationExtras(
  attemptedUrl: string
): { queryParams: { returnUrl: string } } | undefined {
  const returnUrl = safeReturnUrl(attemptedUrl);
  return returnUrl ? { queryParams: { returnUrl } } : undefined;
}
